<script>

import CountDownItem from "@/components/2025/CountDown/CountDownItem.vue";
import moment from "moment";
export default {
  name: "CountDown",
  components: {
    CountDownItem,
  },
  data(){
    return {
      eventDay: moment("02-07-2025", "DD-MM-YYYY"),
      remainingTime: moment.duration(0),
    }
  },
  methods:{
    getRemainingTime(){
      this.remainingTime = moment.duration(this.eventDay.diff(moment()));
    }
  },
  mounted(){
    this.getRemainingTime();
    setInterval(() => {
      this.getRemainingTime();
    }, 1000);
  }
}
</script>
<template>
  <div class="mt-5" v-if="remainingTime > 0" >
    <h6 class="text-white mb-2 text-center text-md-left" style="font-family: 'sqwaredsemi_bold'">#ROAD_TO_MGE2025</h6>
    <div class="d-flex justify-content-start align-items-center" >
      <CountDownItem :value="Math.floor(remainingTime.asDays())" unit="DD" :max="100"/>
      <CountDownItem :value="remainingTime.hours()" unit="HH" :max="24"/>
      <CountDownItem :value="remainingTime.minutes()" unit="MM" :max="60"/>
      <CountDownItem :value="remainingTime.seconds()" unit="SS" :max="60"/>
    </div>
  </div>

</template>
